// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8vdl7","leftCol":"styles_leftCol__0FmlM","rightCol":"styles_rightCol__phtrH","tooltip":"styles_tooltip__TTNWq","sold":"styles_sold__MCtNT"};